import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { InputField, Placeholder, Wrapper } from './Input.styles';

function Input({
  id,
  value = '',
  placeholder = '',
  onChange,
  normalizeValue = (functionValue) => functionValue,
  formatValue = (functionValue) => functionValue,
  placeholderColor = '',
  ...rest
}) {
  const handleValueChange = (event) => {
    onChange(normalizeValue(event.target.value), event.target.name);
  };

  return (
    <Wrapper htmlFor={id}>
      <InputField
        name={id}
        id={id}
        data-empty={!value?.toString()?.length}
        value={formatValue(value)}
        onChange={handleValueChange}
        {...rest}
      />

      <Placeholder $forceColor={placeholderColor}>{placeholder}</Placeholder>
    </Wrapper>
  );
}

Input.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  normalizeValue: PropTypes.func,
  formatValue: PropTypes.func,
  placeholderColor: PropTypes.string,
};

export default memo(Input);
